import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListPseudoCell } from './emsp-bo-emsp-user-list-pseudo.cell';
import { EmspBoEmspUserListPseudoHeader } from './emsp-bo-emsp-user-list-pseudo.header';

export const EmspBoEmspUserListPseudoColumn: IdentifiedColumnDef<
  EmspUserModel,
  EmspUserModel['pseudo']
> = {
  enableSorting: true,
  header: EmspBoEmspUserListPseudoHeader,
  cell: EmspBoEmspUserListPseudoCell,
};
